'use strict';

module.exports = {
    HTTP_URL: 'http://a.tiles.mapbox.com',
    HTTPS_URL: 'https://a.tiles.mapbox.com',
    FORCE_HTTPS: true,
    REQUIRE_ACCESS_TOKEN: true
};
